import request from '../request'

//仓储费明细
export const storage_money_request = p => {
    return request({
        method:'GET',
        url:'money_bill/storage',
        params: p
    })
}